import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AboutComponent } from './about/about.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTabsModule } from '@angular/material/tabs';
import { AmplifyAuthenticatorModule } from '@aws-amplify/ui-angular';
import { LoginComponent } from './login/login.component';
import { RootGuard } from './root.guard';
@NgModule({
  declarations: [
    AppComponent,
    AboutComponent,
    LoginComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatTabsModule,
    AmplifyAuthenticatorModule,
  ],
  providers: [
    RootGuard,
  ],
  bootstrap: [
    AppComponent,
  ]
})
export class AppModule { }
